enum CachedResponseStateEnum {
	fresh = 'fresh',
	stale = 'stale'
}
export default CachedResponseStateEnum;
